import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        this.setState({ info });
        // Keep console logging for dev debugging.
        // eslint-disable-next-line no-console
        console.error('UI crashed:', error, info);
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        const message = this.state.error?.message || 'Unknown error';
        const stack = this.state.info?.componentStack || '';

        return (
            <div style={{ padding: 18, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif' }}>
                <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 10, color: '#111827' }}>
                    Monsurv UI error
                </div>
                <div style={{ color: '#b91c1c', fontWeight: 700, marginBottom: 12 }}>
                    {message}
                </div>
                {stack ? (
                    <pre style={{ whiteSpace: 'pre-wrap', background: '#111827', color: '#fff', padding: 12, borderRadius: 10, fontSize: 12, overflow: 'auto' }}>
                        {stack}
                    </pre>
                ) : null}
                <div style={{ marginTop: 12, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                    <button
                        type="button"
                        onClick={() => window.location.reload()}
                        style={{ padding: '8px 12px', fontWeight: 800, cursor: 'pointer' }}
                    >
                        Reload
                    </button>
                    <button
                        type="button"
                        onClick={() => this.setState({ hasError: false, error: null, info: null })}
                        style={{ padding: '8px 12px', fontWeight: 800, cursor: 'pointer' }}
                    >
                        Try continue
                    </button>
                </div>
            </div>
        );
    }
}
